module.exports = __webpack_public_path__ + "static/media/organizer_3.eadf745a.jpg";